import { projectAPI, projectAPI1 } from "../../api's/index";
import axios from "axios";
import { getHeaders, commonApiCall } from "../../utils/index";
var qs = require("qs");

export const getProjectData = async (params) => {
  const response = await commonApiCall({
    method: "get",
    url: projectAPI1,
    params: params,
  });
  return response;
};

export const getUserProjectData = async (params) => {
  const response = await commonApiCall({
    method: "get",
    url: projectAPI1 + "getProject/",
    params: params,
  });
  return response;
};

export const postProjectData = async (data) => {
  const response = await commonApiCall({
    method: "post",
    url: projectAPI1,
    data: data,
  });
  return response;
};

export const editProjectData = async (data, id) => {
  try {
    const headers = getHeaders();
    const response = await axios({
      method: "patch",
      url: projectAPI1 + id + "/",
      data: data,
      headers: headers,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteProjectData = async (id) => {
  try {
    const headers = getHeaders();
    console.log(projectAPI1 + id);
    const response = await axios({
      method: "delete",
      url: projectAPI1 + id + "/",
      headers: headers,
    });
    return response;
  } catch (error) {
    throw error;
  }
};
